import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, Observable, Subject, Subscription } from 'rxjs';
import { SharedService } from '../../../../shared/services/shared.service';
import { Store } from '@ngrx/store';
import { getCurrentLanguage, NotificationService, State, UserInfoService } from '@ecap3/core';
import {
    FuseConfigService,
    FuseSidebarService,
    TemplateAtlasSharedService
} from '@ecap3/template-atlas';
import { filter, first, map, take, takeUntil } from 'rxjs/operators';
import { forEach, orderBy } from 'lodash';
import { CommonService } from '../../../../shared/services/common.service';
import { MessageNotificationKeys } from 'src/app/business/app-chat/constants/chat-panel.constant';
import { NavigationEnd, Router } from '@angular/router';
import { OfflineNotificationService } from 'src/app/shared/services/offline-notification.service';
import { DELTA_CONFIG } from 'src/app/delta-config/constant/delta-config.constant';
import { DeltaGqlService } from 'src/app/shared/services/delta-gql.service';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeltaBusinessService } from 'src/app/shared/services/delta-business.service';
import { LeaveOverviewBottomsheetComponent } from '../leave-overview-bottomsheet/leave-overview-bottomsheet.component';
import { deepSafeAccess } from 'src/app/shared/helpers/deep-safe-access';
import { NOTIFICATION_MESSAGE_STRUCTURES } from 'src/app/delta-config/constant/notification-keys.constant';
const SIDE_PANEL = 'quickPanel';
@Component({
    selector: 'app-notification',
    templateUrl: './app-notification-list.component.html',
    styleUrls: ['./app-notification-list.component.scss']
})
export class AppNotificationListComponent implements OnInit, OnDestroy {
    lang$: Observable<string>;
    langSub: Subscription;
    unsubscribeAll$: Subject<boolean> = new Subject<boolean>();
    private notificationQueryPayload: any;
    private onlyMessageQueryPayload: any;
    totalNotification = 0;
    displayingNotificationcount = 0;
    notificationActive: boolean;
    showLoader = false;
    showNotificationLoader = false;
    checkNotificationOninit = true;
    notificationIdMarkedAsRead = [];
    notifications: any[] = [];
    excludedNotificationList: string[] = [];
    private readonly allowedResponseKeys = new Set<string>([
        'SuccessfullyCalculatedMonthlyPayroll',
        'FailedCalculationMonthlyPayroll',
        'OpenPositionRequestSuccessful',
        'ApprovedLeaveCancelled',
        'AssignSubOnsiteLeader',
        'AcceptOrRejectLeaveRequest',
        'AddedOrRemovedLeave',
        'EmployeeReservation',
        'LeaveRequestReminder',
        'LeaveRequestLastDayReminder',
        'TimeInputReminder',
        'VehiclePlanNotificationSent',
        'AssignedToVehicle',
        'RemovedFromVehicle',
        'InventoryTransactionRequest',
        'SuccessfullyGeneratedPayslips',
        'AnnouncementCreatedSuccessfully',
        'LeaveRequestNotifaction',
        'WishlistDeadlineExpired',
        'EmployeeWishListSent',
        'EmployeeWishListSentSingleProject',
        'ProjectInformationChange',
        'ProjectDescriptionChange',
        'AssignedOnsiteLeader',
        'AssignedLogisticPerson',
        'StandingRemoval',
        'ThreadRecipientsUpdated',
        'PayslipUpdated',
        'QualityReportCreated',
        'WishlistAcceptingExpirationReminder',
        'AnnouncementByRoleCreatedSuccessfully',
        'ProjectInfoUpdatedSuccessfully',
        'DocumentUpdatedInProject',
        'NotifyAboutBookingSuccessfully',
        'EmployeeBooking',
        'OpenPositionRequested',
        'EORTPlaceUpdated',
        'ProjectManpowerScheduleChanged',
        'ProjectCancelled',
        'ProjectGenerated',
        'VehiclePlanningIncomplete',
        'ProjectExpirationNotification',
        'PickUpTimeAndPlaceUpdated',
        'ReserveCancellation',
        'AdminApprovalOfProfileChange',
        'CommonResponseKey',
        'QualityReportReviewed',
        'projectRequest',
        'projectBooked'
    ]);
    private readonly responseKeysWithSingleDateVariant = new Set<string>([
        'AcceptOrRejectLeaveRequest',
        'AddedOrRemovedLeave'
    ]);
    messageNotificationKeys = MessageNotificationKeys;
    pageObj = {
        PageNumber: 1,
        PageSize: 50
    };
    totalRecord = 0;
    loadedData = 0;
    private _unsubscribeAll: Subject<any>;
    private assignmentInvalidStatus = 'invalid';
    _loggedInPersonId: string;

    constructor(
        private sharedService: SharedService,
        private readonly translateService: TranslateService,
        private store: Store<State>,
        private fuseConfig: FuseConfigService,
        private atlasSharedService: TemplateAtlasSharedService,
        private commonService: CommonService,
        private router: Router,
        private offlineNotificationService: OfflineNotificationService,
        private _fuseSidebarService: FuseSidebarService,
        private deltaGqlService: DeltaGqlService,
        private snackBar: MatSnackBar,
        private notificationService: NotificationService,
        private deltaBusinessService: DeltaBusinessService,
        private bottomSheet: MatBottomSheet,
        private _userInfoService: UserInfoService
    ) {
        this._unsubscribeAll = new Subject();
        this.lang$ = this.store.select(getCurrentLanguage);
    }

    ngOnInit(): void {
        // this.sharedService.sendToolbarData({
        //     title: 'Notifications',
        //     route: ''
        // });  
        this.sharedService.sendToolbarData(null);

        this.langSub = this.lang$.subscribe((lang) =>
            this.translateService.use(lang)
        );
        //this.getNotificationConfig();
        this.subscribeForNotificationBtnClick();
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                if (this._fuseSidebarService.getSidebar('quickPanel')) {
                    this._fuseSidebarService.getSidebar('quickPanel').close();
                }
               });  
    }

    subscribeForNotificationBtnClick() {
        this.offlineNotificationService.onNotificationBtnClicked
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((event) => {
                if (event && this.atlasSharedService.getCounter()) {
                    this.notificationActive = false;
                }
                this.getNotificationConfig();
            });
    }

    ngOnDestroy(): void {
        this.unsubscribeAll$.next(null as any);
        this.unsubscribeAll$.complete();
    }

    getNotificationConfig() {
        this.fuseConfig
            .getConfig()
            .pipe(takeUntil(this.unsubscribeAll$))
            .subscribe((newSettings) => {
                if (
                    newSettings &&
                    newSettings.layout &&
                    newSettings.layout.notificationQueryPayload
                ) {
                    this.notificationQueryPayload =
                        newSettings.layout.notificationQueryPayload;
                    this.onlyMessageQueryPayload =
                        newSettings.layout.onlyMessageQueryPayload;
                    this.showAllNotification();
                }
            });
    }

    showAllNotification(loadmore?: boolean) {
        // if (!this.notificationActive || loadmore) {
        //     this.showLoader = true;
        //     this.showNotificationLoader = true;
        //     this.notificationActive = true;
        //     this.checkNotificationOninit = false;
        //     this.denormalizeNotification();
        // }
        this.showLoader = true;
        this.showNotificationLoader = true;
        this.notificationActive = true;
        this.checkNotificationOninit = false;
        this.denormalizeNotification(loadmore);
    }

    denormalizeNotification(loadmore) {
        if (this.notificationQueryPayload) {
            this.notificationQueryPayload.PageNumber = loadmore
                ? this.pageObj.PageNumber
                : 1;
            this.notificationQueryPayload.PageSize = this.pageObj.PageSize;
            //this.notificationQueryPayload.OnlyUnread = false;
            this.offlineNotificationService
                .getAllNotificationForFloatingPanelLocal(
                    this.notificationQueryPayload
                )
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe({
                    next: (resp: any) => {
                        this.totalRecord = resp['TotalCount'];
                        const response = resp['Data'];
                        if (!loadmore) this.notifications = [];
                        this.notificationIdMarkedAsRead = [];
                        this.notifications =
                            response && response.value && response.value.length
                                ? this.notifications.concat(response.value)
                                : response.length
                                ? this.notifications.concat(response)
                                : [];
                        if (this.notifications.length) {
                            forEach(this.notifications, (value, index) => {
                                value.TimeDiffStr = this.generateTimeString(
                                    value.CreatedTime
                                );
                            });
                            this.loadedData = this.notifications.length;
                        }

                        this.notifications = orderBy(
                            this.notifications,
                            ['CreatedTime'],
                            ['desc']
                        );
                        this.notifications = this.generateMessageFromKey(
                            this.notifications
                        );
                        this.notifications = this.notifications.filter(
                            (notification) => this.isAllowedResponseKey(notification)
                        );
                        this.showLoader = false;
                        this.notificationActive = true;
                        this.showNotificationLoader = false;
                    },
                    error: (error) => {
                        console.log('Error fetching notifications:', error);
                        this.showLoader = false;
                        this.showNotificationLoader = false;
                    }
                });
        } else {
            console.log('no payload has been set for notification query');
        }
    }

    public loadMore() {
        if (this.totalRecord <= this.loadedData) return;
        this.pageObj.PageNumber++;
        this.showAllNotification(true);
    }

    generateMessageFromKey(notificationArray: any[]) {
        forEach(notificationArray, (notification) => {
            this.normalizeDenormalizedPayload(notification);
            this.normalizeNotificationTime(notification);

            if (deepSafeAccess(notification.DenormalizedPayload, [ 'messageKey' ])) {
                this.applyMessageKeyTranslation(notification);
            } else if (deepSafeAccess(notification.DenormalizedPayload, [ 'key' ])) {
                this.applyKeyTranslation(notification);
            } else if (
				deepSafeAccess(notification.DenormalizedPayload, [ 'Message' ]) &&
				notification.DenormalizedPayload.Message.indexOf(' ') <= -1
            ) {
                this.applyMessageTranslation(notification);
            } else if (
				Object.keys(NOTIFICATION_MESSAGE_STRUCTURES).includes(deepSafeAccess(notification.Payload, [ 'ResponseKey' ])) &&
				deepSafeAccess(notification.DenormalizedPayload, [ 'Result' ])
			) {
				this.applyResponseKeyTemplate(notification);
			}
        });
        return this.filterExcludedNotifications(notificationArray);
    }

    private normalizeDenormalizedPayload(notification: any) {
        if (!notification?.DenormalizedPayload) {
            notification.DenormalizedPayload = {};
        } else if (this.isJSON(notification.DenormalizedPayload)) {
            notification.DenormalizedPayload = JSON.parse(
                notification.DenormalizedPayload
            );
        }
    }

    private normalizeNotificationTime(notification: any) {
        notification.DenormalizedPayload['time'] =
            notification.DenormalizedPayload['time'] ||
            notification.DenormalizedPayload['Time'] ||
            '';
    }

    private applyMessageKeyTranslation(notification: any) {
        let myTranslatedValue = '';
        this.translateService
            .stream(notification.DenormalizedPayload.messageKey)
            .pipe(takeUntil(this.unsubscribeAll$))
            .subscribe({
                next: (val) => {
                    myTranslatedValue = val;
                }
            });
        notification.DenormalizedPayload['keyBeforeTranslation'] =
            notification.DenormalizedPayload.messageKey;
        notification.DenormalizedPayload['message'] =
            this.replacePlaceholderValues(
                myTranslatedValue,
                notification.DenormalizedPayload
            );
    }

    private applyKeyTranslation(notification: any) {
        if (typeof notification.DenormalizedPayload.message === 'object') {
            notification.DenormalizedPayload.messageObj = JSON.parse(
                JSON.stringify(notification.DenormalizedPayload.message)
            );
        }
        let myTranslatedValue = '';
        this.translateService
            .stream(notification.DenormalizedPayload.key)
            .pipe(takeUntil(this.unsubscribeAll$))
            .subscribe({
                next: (val) => (myTranslatedValue = val)
            });
        notification.DenormalizedPayload['keyBeforeTranslation'] =
            notification.DenormalizedPayload.key;
        notification.DenormalizedPayload['message'] =
            this.replacePlaceholderValues(
                myTranslatedValue,
                notification.DenormalizedPayload.messageObj
            );
    }

    private applyMessageTranslation(notification: any) {
        let myTranslatedValue = '';
        this.translateService
            .stream(notification.DenormalizedPayload.Message)
            .pipe(takeUntil(this.unsubscribeAll$))
            .subscribe({
                next: (val) => {
                    myTranslatedValue = val;
                }
            });
        notification.DenormalizedPayload['keyBeforeTranslation'] =
            notification.DenormalizedPayload.Message;
        notification.DenormalizedPayload['message'] =
            this.replacePlaceholderValues(
                myTranslatedValue,
                notification.DenormalizedPayload
            );
    }

    private applyResponseKeyTemplate(notification: any) {
        const structures: Record<string, string> = NOTIFICATION_MESSAGE_STRUCTURES;
        const responseKey = notification.Payload.ResponseKey;
        const result = notification.DenormalizedPayload.Result;
        const singleDateKey = `${responseKey}SingleDate`;
        const messageStructureKey =
            this.responseKeysWithSingleDateVariant.has(responseKey) &&
            this.isSameCalendarDay(result.StartDateTime, result.EndDateTime)
                ? singleDateKey
                : responseKey;
        notification.DenormalizedPayload.MessageKey = this.getTranslatedMessage(
            structures[messageStructureKey],
            result
        );
    }

    private filterExcludedNotifications(notificationArray: any[]) {
        return notificationArray.filter(
            (item: any) =>
                !item.DenormalizedPayload['keyBeforeTranslation'] ||
                (item.DenormalizedPayload['keyBeforeTranslation'] &&
                    this.excludedNotificationList.indexOf(
                        item.DenormalizedPayload['keyBeforeTranslation']
                    ) < 0)
        );
    }

    replacePlaceholderValues(text, valueObj) {
        forEach(valueObj, (value, key) => {
            if (value) {
                const translatedValue =
                    key == 'CustomerSalutation' ||
                    key == 'customerSalutation' ||
                    key == 'AdvisorSalutation'
                        ? this.translateService.stream(value)
                        : null;
                if (key === 'Type') {
                    value = value.split(',').join(', ');
                }
                text = translatedValue
                    ? text.split('[' + key + ']').join(translatedValue)
                    : text.split('[' + key + ']').join(value);
            } else {
                text = text.split('[' + key + ']').join('');
            }
        });
        return text;
    }

    isJSON(str) {
        try {
            const obj = JSON.parse(str);
            if (obj && typeof obj === 'object' && obj !== null) {
                return true;
            }
        } catch (err) {}
        return false;
    }

    generateTimeString(dateSent) {
        let str = '';
        const diff = this.commonService.getDateTimeDiffWithCurrentDate(
            dateSent,
            true
        );
        if (diff == 1) {
            str = 'YESTERDAY';
        } else if (diff === 0) {
            let hrDiff = 0;
            hrDiff = this.commonService.getDateTimeDiffWithCurrentDate(
                dateSent,
                false,
                true,
                false
            );
            if (hrDiff >= 1) {
                str = this.makeStr(hrDiff, 'HR(S) AGO');
            } else if (hrDiff === 0) {
                const minDiff =
                    this.commonService.getDateTimeDiffWithCurrentDate(
                        dateSent,
                        false,
                        false,
                        true
                    );
                if (minDiff >= 1) str = this.makeStr(minDiff, 'MIN(S) AGO');
                else str = 'NOW';
            }
        } else str = '';
        return str;
    }

    private makeStr(diff: number, nextpart: string) {
        return diff.toString() + ' ' + nextpart;
    }

    responseKeyMapping = {
        EmployeeReservation: this._gotoProjectBrief.bind(this),
        OpenPositionRequested: this._gotoOpenPositionPage.bind(this),
        EmployeeWishListSent: this._gotoWishlist.bind(this),
        EmployeeWishListSentSingleProject: this._gotoWishlist.bind(this),
        EmployeeBooking: this.gotoProjectBriefsWithStandingId.bind(this),
        ProjectManpowerScheduleChanged:
            this.gotoProjectBriefsWithStandingId.bind(this),
        EORTPlaceUpdated: this.gotoProjectBriefsWithStandingId.bind(this),
        AssignedToVehicle: this.gotoProjectBriefsWithStandingId.bind(this),
        PickUpTimeAndPlaceUpdated:
            this.gotoProjectBriefsWithStandingId.bind(this),
        VehiclePlanNotificationSent:
            this.gotoProjectBriefsWithStandingId.bind(this),
        WishlistDeadlineExpired: this._gotoProjectWithSingleSlashUrl.bind(this),
        VehiclePlanningIncomplete:
            this._gotoProjectWithSingleSlashUrl.bind(this),
        ProjectExpirationNotification:
            this._gotoProjectWithSingleSlashUrl.bind(this),
        WishListSent: this._gotoWishlist.bind(this),
        ThreadRecipientsUpdated: this._gotoChats.bind(this),
        AnnouncementCreatedSuccessfully: this._gotoAnnouncement.bind(this),
        AssignedOnsiteLeader: this._gotoProjectBriefFromOnsite.bind(this),
        DocumentUpdatedInProject: this._gotoDMS.bind(this),
        AssignSubOnsiteLeader: this._gotoSubOnsiteLeaderManpower.bind(this),
        AdminApprovalOfProfileChange: this._gotoNotificationRoute.bind(this),
        InventoryTransactionRequest: this._goToInventory.bind(this),
        CommonResponseKey: this._gotoSchedule.bind(this),
        LeaveRequestReminder: this._gotoSchedule.bind(this),
        LeaveRequestNotifaction: this.openOverview.bind(this),
        AcceptOrRejectLeaveRequest: this._gotoSchedule.bind(this),
        AssignedLogisticPerson: this._gotoProjectBriefFromLogisticPerson.bind(this),
        TimeInputReminder: this.gotoProjectBriefsWithStandingId.bind(this),
        QualityReportReviewed: this._gotoNotificationRoute.bind(this),
        AddedOrRemovedLeave: this._gotoSchedule.bind(this),
        LeaveRequestLastDayReminder: this._gotoSchedule.bind(this),
        RemovedFromVehicle: this.gotoProjectBriefsWithStandingId.bind(this),
        ProjectInformationChange: this._gotoSchedule.bind(this),
        ProjectDescriptionChange: this._gotoSchedule.bind(this),
        QualityReportCreated: this._gotoQualityReport.bind(this),
        WishlistAcceptingExpirationReminder: this._gotoWishlist.bind(this),
        AnnouncementByRoleCreatedSuccessfully: this._gotoAnnouncement.bind(this)
    };

    private _gotoNotificationRoute(notification) {
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        if (!detailedRoute) return;
        this.router
        .navigate([`${detailedRoute}`]);
    }

    private openOverview(notification){

        const month = notification.DenormalizedPayload.Result.Month;
        const year = notification.DenormalizedPayload.Result.Year;

        this._userInfoService.getLoggedInPersonInfo().pipe(take(1)).subscribe({
            next: (resp) => {
                this._loggedInPersonId = resp.ItemId;
                this.getOffDaysLeave(month,year, resp.ItemId);
            }
        });
    }

    private getOffDaysLeave(month, year, personId) {
        const filters = `PersonId: '${personId}', ScheduleType: 'leave', LeaveType: {$in: ['day_off', 'vacation']}, Month: ${month}, Year: ${year}, IsMarkedToDelete: false`;
        const sort = `StartDateTime_ZoneSpecific: 1`
        this.deltaGqlService
            .queryAllData(
                DELTA_CONFIG.Entity.ScheduleEvent,
                [
                    'ItemId',
                    'ActionStatus',
                    'AssignmentDate',
                    'AssignmentDate_ZoneSpecific',
                    'StartDateTime',
                    'StartDateTime_ZoneSpecific',
                    'EndDateTime',
                    'EndDateTime_ZoneSpecific',
                    'DeltaEmployeeLeaveId',
                    'DocumentsExpiryDate',
                    'LastActionTakenBypersonId',
                    'LastActionTakenById',
                    'LastActionTakenBy',
                    'EmployeeCategory',
                    'ActionNote',
                    'LeaveType',
                ],
                filters,
                sort
            )
            .pipe(take(1),)
            .subscribe({
                next: (res) => {
                    console.log(res);
                    this.getDeltaEmployeeLeaveSchedule(res.Data);
                },
                error: (error) => {
                    this.snackBar.open('Something went wrong.', null, {
                        duration: 3000
                    });
                }
            });
    }

    private openLeaveBottomSheet(data) {
        const bottomsheetRef = this.bottomSheet.open(LeaveOverviewBottomsheetComponent, {
            data: data,
            disableClose: false
        });
        bottomsheetRef.afterDismissed().pipe(take(1)).subscribe(() => {
            this.closeSidePanel();
        });
    }
    getDeltaEmployeeLeaveSchedule(data){
        const leaveIds = data.map(item => `'${item.DeltaEmployeeLeaveId}'`);
        const filter = `_id: { $in: [${leaveIds}] }`;
        this.deltaGqlService
            .queryAllData(
                DELTA_CONFIG.Entity.DeltaEmployeeLeaveSchedule,
                [
                    'ItemId',
                    'StartDateTime',
                    'EndDateTime',
                    'LeaveType'
                ],
                filter,
                `StartDateTime: 1`
            )
            .pipe(take(1))
            .subscribe({
                next: (res) => {
                    console.log(res);
                    const updatedData: any[] = [];
                    res.Data.map((item: any) => {
                        const startDate = new Date(item.StartDateTime);
                        const endDate = new Date(item.EndDateTime);
                        const currentDate = new Date(startDate);

                        while (currentDate <= endDate) {
                            const status = data.find((schedule:any) => schedule.DeltaEmployeeLeaveId === item.ItemId).ActionStatus;
                            updatedData.push({
                                AssignmentDate: new Date(currentDate),
                                ActionStatus: status,
                                LeaveType: item.LeaveType
                            });

                            currentDate.setDate(currentDate.getDate() + 1);
                        }
                    });

                    let bottomsheetRef: MatBottomSheetRef;
                    bottomsheetRef = this.bottomSheet.open(
                        LeaveOverviewBottomsheetComponent,
                        {
                            data: updatedData,
                            disableClose: false
                        }
                    );

                    bottomsheetRef
                        .afterDismissed()
                        .pipe(take(1))
                        .subscribe({
                            next: (res) => {
                                this.closeSidePanel();
                            }
                        });
                },
                error: (error) => {
                    this.snackBar.open('Something went wrong.', null, {
                        duration: 3000
                    });
                }
            });
    }

    private _gotoSchedule(notification) {
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        if(detailedRoute && detailedRoute.includes('directory/documents')){
            this.router.navigate([`income-and-hours`]).then(()=>{
                this.closeSidePanel();
            });
        }else if(detailedRoute && detailedRoute.includes('projects-briefs')){
            this._gotoProjectWithSingleSlashUrl(notification);
        }else{
            this.router.navigate([`schedule`]).then(()=>{
                this.closeSidePanel();
            });
        }
    }

    private _gotoDMS(notification) {
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        //.....onsite-leader/${projectId}/details...
        const dailyProjectId = detailedRoute.split('/')[2];
        if (!dailyProjectId || !this.checkGuid(dailyProjectId)) return;
        this.router
            .navigate([`projects-wishlist/project-details/${dailyProjectId}/docs`])
            .then(() => {
                this.closeSidePanel();
            });
    }

    public notificationClicked(notification) {
        const responseKey = notification.Payload.ResponseKey;
        const handlerFunction = this.responseKeyMapping[responseKey];
        this.handleIsRead(notification);
        if (handlerFunction) {
            handlerFunction(notification);
        } else {
            console.log('Unhandled Response Key:', responseKey);
        }

        // if (notification.Payload.ResponseKey == 'EmployeeReservation')
        //     this._gotoProjectBrief(notification);
        // else if (notification.Payload.ResponseKey == 'OpenPositionRequested')
        //     this._gotoOpenPositionPage(notification);
        // else if (notification.Payload.ResponseKey == 'EmployeeWishListSent')
        //     this._gotoWishlist(notification);
        // else if (notification.Payload.ResponseKey == 'EmployeeBooking')
        //     this._gotoProjectBrief(notification);
        // else if (
        //     notification.Payload.ResponseKey == 'ProjectManpowerScheduleChanged'
        // )
        //     this._gotoProjectBrief(notification);
        // else if (notification.Payload.ResponseKey == 'EORTPlaceUpdated')
        //     this.gotoProjectBriefsWithStandingId(notification);
        // else if (
        //     notification.Payload.ResponseKey == 'VehiclePlanNotificationSent'
        // )
        //     this.gotoProjectBriefsWithStandingId(notification);
        // else if (notification.Payload.ResponseKey == 'WishlistDeadlineExpired')
        //     this._gotoProjectWithSingleSlashUrl(notification);
        // else if (
        //     notification.Payload.ResponseKey == 'VehiclePlanningIncomplete'
        // )
        //     this._gotoProjectWithSingleSlashUrl(notification);
        // else if (
        //     notification.Payload.ResponseKey == 'ProjectExpirationNotification'
        // )
        //     this._gotoProjectWithSingleSlashUrl(notification);
    }

    private handleIsRead(notification) {
        if (notification.IsRead) return;
        this.atlasSharedService.markingNotificationsAsRead([notification.Id]); // marking notifications as read
        const indx = this.notifications.findIndex((x) => x.Id == notification.Id);
        this.updateUnreadNotificationCount(indx);
    }

    closeSidePanel() {
		this.pageObj.PageNumber = 1;
        this._fuseSidebarService.getSidebar(SIDE_PANEL).close();
    }
    private _gotoProjectBrief(notification) {
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        const mainUrl = detailedRoute.split('?')[0];
        const dailyProjectId = mainUrl.split('/')[2];
        if (!dailyProjectId || !this.checkGuid(dailyProjectId)) return;
        this.sharedService.sendToolbarData({
            title: 'PROJECT_DETAILS',
            route: 'projects-wishlist'
        });
        this.router
            .navigate([`projects-wishlist/project-details/${dailyProjectId}`])
            .then(() => {
                this.closeSidePanel();
            });
    }

    private _gotoProjectBriefFromOnsite(notification) {
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        //.....onsite-leader/${projectId}/details...
        const dailyProjectId = detailedRoute.split('/')[1];
        if (!dailyProjectId || !this.checkGuid(dailyProjectId)) return;
        this.sharedService.sendToolbarData({
            title: 'PROJECT_DETAILS',
            route: 'projects-wishlist'
        });
        this.router
            .navigate([`projects-wishlist/project-details/${dailyProjectId}`])
            .then(() => {
                this.closeSidePanel();
            });
    }

    private async _gotoSubOnsiteLeaderManpower(notification) {
        if (!notification.DenormalizedPayload) return;
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        //.....onsite-leader/${projectId}/details...
        const dailyProjectId = detailedRoute.split('/')[2];
        if (!dailyProjectId || !this.checkGuid(dailyProjectId)) return;
        const isUserRemovedFromProject = await this.isUserRemovedFromProject(dailyProjectId);
        if(isUserRemovedFromProject){
            this.snackBar.open('You have no access to this project.', null, {
                duration: 3000
            });
        } else {
            this.sharedService.sendToolbarData({
                title: 'PROJECT_DETAILS',
                route: 'projects-wishlist'
            });
            this.router
                .navigate([`projects-wishlist/project-details/${dailyProjectId}`])
                .then(() => {
                    this.closeSidePanel();
                });
        }
    }

    private _goToInventory(notification): void {
        this.router
            .navigate([`inventory`])
            .then(() => {
                this.closeSidePanel();
            });
    }

    private async _gotoProjectWithSingleSlashUrl(notification) {
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        const mainUrl = detailedRoute.split('?')[0];
        const dailyProjectId = mainUrl.split('/')[1];
        const productStandingId = mainUrl.split('/')[3];
        if (!dailyProjectId || !this.checkGuid(dailyProjectId)) return;
        const isUserRemovedFromProject = await this.isUserRemovedFromProject(dailyProjectId);
        if(isUserRemovedFromProject){
            this.snackBar.open('You have no access to this project.', null, {
                duration: 3000
            });
            return;
        } 
        this.sharedService.sendToolbarData({
            title: 'PROJECT_DETAILS',
            route: 'projects-wishlist'
        });
        
        this.router
            .navigate([`projects-wishlist/project-details/${dailyProjectId}`],{
                queryParams: productStandingId ? {
                    productStandingId: productStandingId
                } : {}
            })
            .then(() => {
                this.closeSidePanel();
            }); 
    }

    private async gotoProjectBriefsWithStandingId(notification) {
        const detailedRoute = notification.DenormalizedPayload.DetailRoute;
        let mainUrl = detailedRoute.split('?')[0];
        const qparams = detailedRoute.split('?')[1];
        if (notification.Payload.ResponseKey === 'PickUpTimeAndPlaceUpdated')
            mainUrl = '/' + mainUrl;
        const dailyProjectId = mainUrl.split('/')[2];
        const isUserRemovedFromProject = await this.isUserRemovedFromProject(dailyProjectId);
        if(isUserRemovedFromProject){
            this.snackBar.open('You have no access to this project.', null, {
                duration: 3000
            });
            return;
        } 
        const qparamObj = {};
        if (qparams) {
            const qparamArray = qparams.split('&');
            for (const param of qparamArray) {
                const key = param.split('=')[0];
                const value = param.split('=')[1];
                qparamObj[`${key}`] = value;
            }
            this.sharedService.sendToolbarData({
                title: 'PROJECT_DETAILS',
                route: 'projects-wishlist'
            });
            this.router
                .navigate(
                    [`projects-wishlist/project-details/${dailyProjectId}`],
                    { queryParams: qparamObj }
                )
                .then(() => {
                    this.closeSidePanel();
                });
            return;
        }
        if (!dailyProjectId || !this.checkGuid(dailyProjectId)) return;
        this.sharedService.sendToolbarData({
            title: 'PROJECT_DETAILS',
            route: 'projects-wishlist'
        });
        this.router
            .navigate([`projects-wishlist/project-details/${dailyProjectId}`])
            .then(() => {
                this.closeSidePanel();
            });
    }

    async isUserRemovedFromProject(dailyProjectId: string){
        try {
            if(dailyProjectId && this.checkGuid(dailyProjectId)){
                const resp: any = await firstValueFrom(this._userInfoService
                .getLoggedInPersonInfo()
                .pipe(take(1)));

                this._loggedInPersonId = resp.ItemId;

                    const res: any = await firstValueFrom(this.deltaGqlService
                    .queryEntityData(
                        DELTA_CONFIG.Entity.ProductStanding,
                        ['DisplayName'],
                        `'DailyProjectId' : '${dailyProjectId}', 'PersonId': '${this._loggedInPersonId}', 'IsMarkedToDelete': false`
                    )
                    .pipe(take(1)));
                if(deepSafeAccess(res, ['Data','length']) === 0){
                    return true;
                }else{
                    return false;
                }
            }       
            return false;
        } catch (error) {
            this.snackBar.open('Something went wrong.', null, {
                duration: 3000
            });
            return;
        }
    }

    private async _gotoProjectBriefFromLogisticPerson(notification) {
        const detailedRouteFromResponse = notification.DenormalizedPayload.DetailRoute;
        const responseDailyProjectId = detailedRouteFromResponse.split('/')[1];
        if (!responseDailyProjectId || !this.checkGuid(responseDailyProjectId)) return;

        const isUserRemovedFromProject = await this.isUserRemovedFromProject(responseDailyProjectId);
        if(isUserRemovedFromProject){
            this.snackBar.open('You have no access to this project.', null, {
                duration: 3000
            });
        } else {
            this.sharedService.sendToolbarData({
                title: 'PROJECT_DETAILS',
                route: 'projects-wishlist'
            });
            this.router
                .navigate([`projects-wishlist/project-details/${responseDailyProjectId}`])
                .then(() => {
                    this.closeSidePanel();
                });
        }
    }

    private checkGuid(guid: string) {
        // Regular expression to match a GUID pattern
        const guidPattern =
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

        // Test if the input string matches the GUID pattern
        return guidPattern.test(guid);
    }

    private _gotoOpenPositionPage(notification) {
        this.checkOpenPositionIsValid(
            notification.DenormalizedPayload.DetailRoute
        );
        this.closeSidePanel();
    }

    private _gotoWishlist(notification) {
        if(notification.DenormalizedPayload.MessageKey.includes('Multiple wishlist requests')){
            this.router
                .navigate(['projects-wishlist'])
                .then(() => {});
        } else {
            this.checkWisListIsValid(notification.DenormalizedPayload.DetailRoute);
        }
        this.closeSidePanel();
    }

    private checkOpenPositionIsValid(detailRoute: string) {
        const lastIndex = detailRoute.lastIndexOf('=');
        const assigneeId = detailRoute.substring(lastIndex + 1);
        this.checkProductAssignmentStatus(assigneeId, detailRoute, false);
    }

    private checkWisListIsValid(detailRoute: string) {
        const productAssignmentId = detailRoute.split('/')[3];
        this.checkProductAssignmentStatus(
            productAssignmentId,
            detailRoute,
            true
        );
    }

    private checkProductAssignmentStatus(
        productAssignmentId: string,
        detailRoute: string,
        isWisList: boolean
    ) {
        this.deltaGqlService
            .getEntityData(
                DELTA_CONFIG.Entity.ProductAssignment,
                ['Status', 'DailyProjectId', 'WishlistDeadline'],
                `_id:'${productAssignmentId}'`
            )
            .pipe(take(1))
            .subscribe({
                next: (res) => {
                    if (
                        res &&
                        res.Data.length &&
                        res.Data[0].Status === this.assignmentInvalidStatus
                    ) {
                        this.snackBar.open('Project Date has been changed', null, {
                            duration: 3000
                        });
                        return;
                    }

                    if (isWisList) {           
                        this.router.navigateByUrl('/projects-wishlist', { skipLocationChange: true }).then(() => {
                            this.router.navigate(['/projects-wishlist'], { queryParams: { type: 'wishlist' } });
                        });
                    }

                    if (!isWisList) {
                        this.router.navigate(['open-position']).then(() => {});
                    }
                },
                error: (error) => {
                    this.snackBar.open('Something went wrong.', null, {
                        duration: 3000
                    });
                }
            });
    }

    private _gotoChats(notification) {
        this.router.navigate(['chats']).then(() => {
            this.closeSidePanel();
        });
    }

    private _gotoAnnouncement(notification) {
        this.checkIsAnnouncementValid(
            notification,
            notification.DenormalizedPayload.Result
        );
    }

    private checkIsAnnouncementValid(notification, result: any) {
        this.deltaGqlService
            .getEntityData(
                DELTA_CONFIG.Entity.Announcement,
                ['ItemId'],
                `_id:'${result.AnnouncementId}', IsMarkedToDelete: false`
            )
            .pipe(take(1))
            .subscribe({
                next: (res) => {
                    if (res && res.Data && res.Data.length) {
                        const announcementType =
                            notification.DenormalizedPayload.DetailRoute.split(
                                '/'
                            )[2];
                        this.router
                            .navigate(['announcement'], {
                                queryParams: { type: announcementType }
                            })
                            .then(() => {
                                this.closeSidePanel();
                            });
                    } else {
                        this.snackBar.open(
                            'This announcement has been deleted',
                            null,
                            {
                                duration: 3000
                            }
                        );
                    }
                },
                error: (error) => {
                    this.snackBar.open('Something went wrong.', null, {
                        duration: 3000
                    });
                }
            });
    }

    private _gotoQualityReport(notification: any) {
        const qualitySurveyReportId = notification.DenormalizedPayload.Result.QualitySurveyReportId;
        
        this.router.navigate([`quality-reports/${qualitySurveyReportId}/details`]).then(()=>{
            this.closeSidePanel();
        });
    }

    getPropertyFromStringifiedJson(str: string, prop: string): any {
        const obj = JSON.parse(str);
        return obj[prop];
    }

    onMarkAllAsRead() {
        this.showNotificationLoader = true;
        this.offlineNotificationService
            .markAllNotificationAsRead()
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.snackBar.open("mark all notifications as read", null, {
                        duration: 3000
                    });
                    this.updateUnreadNotificationCount();
                },
                error: (error) => {
                    this.showNotificationLoader = false;
                    this.snackBar.open("Something went wrong.", null, {
                        duration: 3000
                    });
                }
            });
    }

    onDeleteAllReadClick() {
		const payload = {
			DeleteAll: false,
			DeleteAllRead: true,
			NotificationIds: [],
		};

		this.deltaBusinessService
			.DeleteNotifications(payload)
			.pipe(take(1))
			.subscribe({
                next: (res: any) => {
                    if (res.body.IsSuccess) {
                        this.showAllNotification();
                        this.snackBar.open(res.body.Data, null, {
                            duration: 3000
                        });
                    } else {
                        this.snackBar.open("Something went wrong.", null, {
                            duration: 3000
                        });
                    }
                },
                error: (error) => {
                    this.snackBar.open("Something went wrong.", null, {
                        duration: 3000
                    });
                }
            });
	}

	onSingleDeleteClick(notificationId) {
		const payload = {
			DeleteAll: false,
			DeleteAllRead: false,
			NotificationIds: [notificationId],
		};
		this.deltaBusinessService
			.DeleteNotifications(payload)
			.pipe(take(1))
			.subscribe({
                next: (res: any) => {
                    if (res.body.IsSuccess) {
                        this.showAllNotification();
                        this.updateUnreadNotificationCount();
                        this.snackBar.open(res.body.Data, null, {
                            duration: 3000
                        });
                    } else {
                        this.snackBar.open("Something went wrong.", null, {
                            duration: 3000
                        });
                    }
                },
                error: (error) => {
                    this.snackBar.open("Something went wrong.", null, {
                        duration: 3000
                    });
                }
            });
	}

    updateUnreadNotificationCount(index ?) {
        this.notificationService
            .getUnreadNotificationCounter()
            .pipe(first())
            .subscribe({
                next: (counter) => {
                    this.showNotificationLoader = false;
                    this.atlasSharedService.setCounter(counter);
                    if (index !== undefined && index !== null) { 
                        this.notifications[index].IsRead = true;
                    } else {
                        this.notifications.forEach((x) => (x.IsRead = true));
                    }
                },
                error: (err) => {
                    this.showNotificationLoader = false;
                    console.error(
                        `[QuickPanelComponent (updateUnreadNotificationCount)] Error: ${err}`
                    );
                }
            });
    }

    handleKeyDown($event){
        console.log("keydown pressed");
    }

	private isSameCalendarDay(start: string, end: string): boolean {
		return !!start && !!end && start === end;
	}

	private getTranslatedMessage(
		message: string,
		data: Record<string, string>
	): string {
		let result = this.resolveData(message, data);

  		result = this.resolveTranslations(result);

  		return result;
	}
	
	private resolveData(
		message: string,
		data: Record<string, string>
	): string {
		let result = '';
		let i = 0;

		while (i < message.length) {
			if (message[i] === '{' && message[i + 1] === '{') {
				const end = message.indexOf('}}', i + 2);
				if (end !== -1) {
					result += data[message.slice(i + 2, end)] || '';
					i = end + 2;
					continue;
				}
			}
			result += message[i++];
		}

		return result;
	}

	private resolveTranslations(message: string): string {
		let result = '';
		let i = 0;

		while (i < message.length) {
			if (message[i] === '[' && message[i + 1] === '[') {
				const end = message.indexOf(']]', i + 2);
				if (end !== -1) {
					result += this.translateService.instant(
						message.slice(i + 2, end)
					).trim();
					i = end + 2;
					continue;
				}
			}
			result += message[i++];
		}

		return result;
	}

    private isAllowedResponseKey(notification: any): boolean {
        const responseKey = notification?.Payload?.ResponseKey;
        return this.allowedResponseKeys.has(responseKey);
    }
}
